// @ts-nocheck
/**
 * fallbackRenderer.ts — Template V2 M3 Fallback Renderer
 *
 * Used by RendererRegistry.dispatch() when no renderer is registered for
 * a given component type. Produces a minimal invisible RenderDescriptor
 * and appends a render.unknown_component_type diagnostic.
 */

import type { ValidationIssue } from '../../diagnostics';
import type {
    ComponentRenderContext,
    ComponentRenderer,
    RenderDescriptor,
} from './types';

const FALLBACK_RENDERER: ComponentRenderer<unknown> = {
  supportedType: 'spacer', // structural placeholder — dispatch bypasses this field for the fallback

  render(context: ComponentRenderContext<unknown>): RenderDescriptor {
    const issue: ValidationIssue = {
      severity: 'warning',
      code: 'render.unknown_component_type',
      message: `No renderer registered for component type "${context.node.type}". Node will not render.`,
      path: context.node.id,
    };
    context.issues.push(issue);

    return {
      nodeId: context.node.id,
      type: context.node.type,
      layout: {
        x: context.node.layout.x,
        y: context.node.layout.y,
        width: context.node.layout.width,
        height: context.node.layout.height,
        zIndex: context.node.layout.zIndex,
      },
      visible: false,
      enabled: false,
      props: {},
      diagnostics: [issue],
    };
  },
};

export { FALLBACK_RENDERER };
